class InfiniteScroll {

    constructor() {

        this.container = document.querySelector('#CollectionProductGrid');

        this.grid = document.querySelector('#main-collection-product-grid');

        this.trigger = document.querySelector('#InfiniteScrollTrigger');

        if (!this.container || !this.grid || !this.trigger)
            return;

        this.loading = false;

        this.sectionId = this.container.dataset.sectionId;

        this.init();

    }

    init() {

        this.observer = new IntersectionObserver(
            entries => {

                if (
                    entries[0].isIntersecting &&
                    !this.loading
                ) {

                    this.loadProducts();

                }

            },
            {
                rootMargin: '300px'
            }
        );

        this.observer.observe(this.trigger);

    }

    async loadProducts() {

        this.loading = true;

        const nextUrl =
            this.trigger.dataset.nextPage;

        if (!nextUrl)
            return;

        const separator =
            nextUrl.includes('?') ? '&' : '?';

        const url =
            nextUrl +
            separator +
            'section_id=' +
            this.sectionId;
console.log(url);
        try {

            const response =
                await fetch(url);

            const html =
                await response.text();

            const parser =
                new DOMParser();

            const doc =
                parser.parseFromString(
                    html,
                    'text/html'
                );

            const newProducts =
                doc.querySelector('#main-collection-product-grid');

            if (newProducts) {

                this.grid.insertAdjacentHTML(
                    'beforeend',
                    newProducts.innerHTML
                );

            }

            const newTrigger =
                doc.querySelector(
                    '#InfiniteScrollTrigger'
                );

            if (newTrigger) {

                this.trigger.dataset.nextPage =
                    newTrigger.dataset.nextPage;

                this.loading = false;

            } else {

                this.observer.disconnect();

                this.trigger.remove();

            }

        } catch (error) {

            console.error(error);

        }

    }

}

document.addEventListener(
    'DOMContentLoaded',
    () => {

        new InfiniteScroll();

    }
);